import { Component, input, OnInit, output } from '@angular/core';
import { IconCheckbox } from '../../icons/i-checkbox';
import { IconThumb } from '../../icons/i-thumb';
import { AudioEffectPlayer } from '../../utils/audio.utils';
import { RidButton } from '../rid-button/rid-button';

@Component({
  selector: 'rid-feedback-toast',
  imports: [RidButton, IconCheckbox, IconThumb],
  templateUrl: './rid-feedback-toast.html',
  host: {
    class: 'absolute bottom-0 w-4xl cursor-pointer',
    // the whole toast continues, so a click on its button (which bubbles up here) continues only once
    '(click)': 'continued.emit()',
    'animate.enter': 'anim-slide-from-bottom',
    'animate.leave': 'anim-slide-to-bottom',
  },
})
export class RidFeedbackToast implements OnInit {
  title = input.required<string>();
  description = input.required<string>();
  variant = input.required<'SUCCESS' | 'INFO'>();

  continued = output<void>();

  ngOnInit(): void {
    AudioEffectPlayer.play({ SUCCESS: 'TOAST_POSITIVE' as const, INFO: 'TOAST_INFO' as const }[this.variant()]);
  }
}
